// 'use strict';
import $ from 'jquery';

class MarsFormScripts {
  constructor() {
    $(
      ':input[type="text"], :input[type="email"], :input[type="tel"], :input[type="number"], :input[type="url"], select'
    ).each(function () {
      $(this).on('focus', function () {
        $(this).parent().parent('.gfield').addClass('active');
        $(this).parent('.fsRowBody, .mc-field-group').addClass('active');
      });
      $(this).on('blur', function () {
        if ($(this).val().length == 0) {
          $(this).parent().parent('.gfield').removeClass('active');
          $(this).parent().parent('.gfield').removeClass('filled');
          $(this).parent('.fsRowBody, .mc-field-group').removeClass('active');
          $(this).parent('.fsRowBody, .mc-field-group').removeClass('filled');
        }
      });
      if ($(this).val().length > 0) {
        $(this).parent().parent('.gfield').addClass('filled');
        $(this).parent('.fsRowBody, .mc-field-group').addClass('filled');
      }
      if ($(this).val() !== '') {
        $(this).parent('.css').addClass('active');
      }
    });

    $('textarea').each(function () {
      $(this).on('focus', function () {
        $(this).parent().parent('.gfield').addClass('active');
        $(this).parent('.fsRowBody, .mc-field-group').addClass('active');
      });
      $(this).on('blur', function () {
        if ($(this).val().length == 0) {
          $(this).parent().parent('.gfield').removeClass('active');
          $(this).parent('.fsRowBody, .mc-field-group').removeClass('active');
        }
      });
      if ($(this).val().length > 0) {
        $(this).parent().parent('.gfield').addClass('filled');
        $(this).parent('.fsRowBody, .mc-field-group').addClass('filled');
      }
      if ($(this).val() != '') {
        $(this).parent('.css').addClass('active');
      }
    });
  }
}

export default MarsFormScripts;
